import styled from 'styled-components';

export const Line = styled.div`
  .good {
    color: green;
  }

  .alert {
    color: red;
  }
`;
